export default `---
slug: vietnam
country: Vietnam
countryCode: VNM
continent: Asia
year: 2022
title: "Vietnam"
description: "From Hanoi to Ho Chi Minh — pho, motorbikes, and karst limestone scenery."
thumbnail: /images/travels/VNM/vietnam_thumb.jpg
relatedLinks: []
---
![vietnam](/images/travels/VNM/vietnam_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Vietnam and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
